import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ProtectedRoute from './components/common/ProtectedRoute';

// CSS Styling
import './App.css';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import FundingListPage from './pages/FundingListPage';
import FundingDetailPage from './pages/FundingDetailPage';
import ProfilePage from './pages/ProfilePage';
import FundingListsPage from './pages/FundingListsPage';
import EmailVerificationPage from './pages/EmailVerificationPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import FarmManagementPage from './pages/FarmManagementPage';
import AlertsPage from './pages/AlertsPage';
import FAQPage from './pages/FAQPage';
import BlogPostPage from './pages/BlogPostPage'
import ProfileSignUpForm from './components/auth/ProfileSignUpForm';

// Cookies
import CookieBanner from './components/common/CookieBanner';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Header className="pdf-hidden"/>
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/verify-email" element={<EmailVerificationPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/funding" element={<FundingListPage />} />              
              <Route path="/funding/:slug" element={<FundingDetailPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage/>}/>
              <Route path="/complete-profile" element={<ProfileSignUpForm />} />
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/funding-lists" 
                element={
                  <ProtectedRoute>
                    <FundingListsPage />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/alerts"
                element={
                  <ProtectedRoute>
                    <AlertsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/farm-management"
                element={
                  <ProtectedRoute>
                    <FarmManagementPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer className="pdf-hidden"/>
          <CookieBanner />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;